export const EXPERIMENTS = {
  ENABLE_MULTILINE_ADDRESS: 'specs.forms.MultilineAddressInTemplates',
  SHOW_DEMO_FORM: 'specs.forms.ShowDemoForm',
  ENABLE_PRESET_TAB: 'specs.forms.EnablePresetTab',
  TEMPLATE_DESIGNER: 'specs.forms.TemplateDesigner',
  REMOVE_BOOKINGS_DEPENDENCY: 'specs.services.RemoveBookingsDependency',
  BIF_ON_MEETINGS_CHANGE: 'specs.bookings.BifOnMeetingsInstallOnlyMeetings',
  SCHEDULING_INSTALL_MODE: 'specs.bookings.BifOnMeetingsInstallMode',
  BOXLESS_TEXT_STYLES: 'specs.forms.BoxlessTextStyles',
  ENABLE_HEADING_LEVELS: 'specs.forms.EnableHeadingLevels',
};
